export default function formatTime(seconds?: number): string {
  if (!seconds || !isFinite(seconds) || seconds <= 0) return '0:00';
  const secs = Math.floor(seconds % 60).toString().padStart(2, '0');
  const mins = Math.floor(seconds / 60);
  return `${mins}:${secs}`;
}
